import WeblabStore from 'stores/WeblabStore';
import { reduce } from 'lodash';
import { A2C_WEBLABS } from '../../shared/selectors/bootstrapData';

class WeblabHelper {
  static Constants = {
    CONTROL: 'C',
    TREATMENT1: 'T1',
  };

  static getWeblabsMap() {
    return reduce(WeblabStore.getState().weblabs, (acc, curr) => {
      const weblabName = A2C_WEBLABS[curr.experiment];
      if (weblabName) {
        acc[weblabName] = curr.treatment !== undefined
          && curr.treatment === WeblabHelper.Constants.TREATMENT1;
      }
      return acc;
    }, {});
  }

  static isT1(weblabName) {
    let isTreatment = false;
    WeblabStore.getState().weblabs.forEach((weblab) => {
      if (weblab.experiment === weblabName
          && weblab.treatment === WeblabHelper.Constants.TREATMENT1) {
        isTreatment = true;
      }
    });
    return isTreatment;
  }

  static isControl(weblabName) {
    let isControl = false;

    WeblabStore.getState().weblabs.forEach((weblab) => {
      if (weblab.experiment === weblabName
          && weblab.treatment === WeblabHelper.Constants.CONTROL) {
        isControl = true;
      }
    });
    return isControl;
  }
}

export default WeblabHelper;
